<template>
    <div>
        <loader v-if="isLoading" />

        <g-button
            v-else
            :type="buttonType"
            icon="plus"
            theme="live"
            shape="round"
            size="large"
            @click="handleOpenAddPayoutMethodDrawer()"
        >
            Add Payout Method
        </g-button>

        <AddPayoutMethodDrawer
            :payout-account="payoutAccount"
            :visible="isAddPayoutMethodDrawerOpen"
            @close="hideAddPayoutMethodDrawer()"
            @refresh-payout-account="handleRefreshPayoutAccount"
        />
    </div>
</template>

<script>
    import { ref, toRefs, watch } from 'vue-demi';
    import { get } from 'lodash';
    import { EVENT_NAME_PAYOUTS_ADD_METHOD_VIEWED } from '../../../../../app-v2/constants/analytics-events';
    import useToggle from '../../../../composables/use-toggle';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import useWhiteLabeling from '../../../../composables/use-white-labeling';
    import useContactStore from '../../../../../stores/contact';
    import AddPayoutMethodDrawer from './AddPayoutMethodDrawer.vue';

    export default {
        name: 'AddPayoutMethod',
        props: {
            isLoading: {
                type: Boolean,
                default: false
            },
            payoutAccount: {
                type: Object,
                default: null
            },
            forceOpenDrawer: {
                type: Boolean,
                default: false
            }
        },
        components: { AddPayoutMethodDrawer },
        setup(props, context) {
            const events = useEventTracking();
            const contact = useContactStore().data;

            const buttonType = ref('primary');
            if (props.payoutAccount?.payout_method_id) {
                buttonType.value = '';
            }

            const {
                currentValue: isAddPayoutMethodDrawerOpen,
                setTrue: showAddPayoutMethodDrawer,
                setFalse: hideAddPayoutMethodDrawer
            } = useToggle(false);

            const handleRefreshPayoutAccount = () => {
                context.emit('refresh-payout-account');
            };

            const handleOpenAddPayoutMethodDrawer = () => {
                events.trackEvent(EVENT_NAME_PAYOUTS_ADD_METHOD_VIEWED, {
                    contact_id: contact.id,
                    is_whitelabled: useWhiteLabeling().isWhiteLabeled(),
                    has_pending_payout: contact.has_pending_payout,
                    has_additional_payout_method: props.payoutAccount?.external_account?.payout_methods.length > 0,
                    referrer: get(window.SERVER_DATA, 'referer', null)
                });
                showAddPayoutMethodDrawer();
            };

            const { forceOpenDrawer } = toRefs(props);
            watch(forceOpenDrawer, () => {
                if (forceOpenDrawer.value) {
                    handleOpenAddPayoutMethodDrawer();
                }
            });

            return {
                buttonType,

                //toggle drawer
                isAddPayoutMethodDrawerOpen,
                hideAddPayoutMethodDrawer,
                handleOpenAddPayoutMethodDrawer,

                handleRefreshPayoutAccount
            };
        }
    };
</script>
